export const envs = {
  "production": true,
  "gtmId": "GTM-T2LN4JFM",
  "siteUrl": "https://www.sheyda.com",
  "authUrl": "https://mikasa.sheyda.com/graphql",
  "supportUrl": "https://support.sheyda.com/graphql",
  "approveTvUrl": "https://mikasa.sheyda.com/approveTvGraphql",
  "accountUrl": "https://accounts.sheyda.com/query",
  "apiUrl": "https://api.sheyda.com/query",
  "playPalUrl": "https://playpal.sheyda.com",
  "analyticsUrl": "https://analytics.sheyda.com/events",
  "ssrApiUrl": "http://sheida-backend-nginx-service-ssr.sheida-backend-api/query",
  "viewCountUrl": "https://gaze.sheyda.com/v1",
  "xSourceP": "202314",
  "sentryDsn": "https://03af5d6d7e8c15495335413dfc1494f7@sentry.sheida.cloud/3",
  "recaptchaKey": "6Ld9xGcqAAAAAKlfEABnFLpE86FYbAQZaLurUqs7"
};
